module.exports = __webpack_public_path__ + "img/articleManagement.fdcd011b.png";